import {ViewType} from "../../../../core/gd/const/views/view-type"

export const EVENT_BUS_MY_WORK_SUBMENU_CHANGED = "my-work-submenu:changed"
export const MY_WORK_LOG_VIEW = "my-work:log-view"

export enum MyWorkViewName {
    MY_WORK_VIEW_TYPE       = 'type',
    MY_WORK_VIEW_DAY        = 'day',
    MY_WORK_VIEW_SPLIT      = 'split',
    MY_WORK_VIEW_BOARD      = 'board',
    MY_WORK_VIEW_CALENDAR   = 'calendar',
    MY_WORK_VIEW_UPCOMING   = 'upcoming',
    MY_WORK_VIEW_PROJECT    = 'project',
    MY_WORK_VIEW_FROM_USER  = 'from-user',
    MY_WORK_VIEW_PRIORITY   = 'priority',
}


export const myWorkViewDictionary: {[k in ViewType]?: MyWorkViewName} = {
    [ViewType.MY_WORK_VIEW_TYPE]        : MyWorkViewName.MY_WORK_VIEW_TYPE,
    [ViewType.MY_WORK_VIEW_DAY]         : MyWorkViewName.MY_WORK_VIEW_DAY,
    [ViewType.MY_WORK_VIEW_SPLIT]       : MyWorkViewName.MY_WORK_VIEW_SPLIT,
    [ViewType.MY_WORK_VIEW_BOARD]       : MyWorkViewName.MY_WORK_VIEW_BOARD,
    [ViewType.MY_WORK_VIEW_CALENDAR]    : MyWorkViewName.MY_WORK_VIEW_CALENDAR,
    [ViewType.MY_WORK_VIEW_UPCOMING]    : MyWorkViewName.MY_WORK_VIEW_UPCOMING,
    [ViewType.MY_WORK_VIEW_PROJECT]     : MyWorkViewName.MY_WORK_VIEW_PROJECT,
    [ViewType.MY_WORK_VIEW_PRIORITY]    : MyWorkViewName.MY_WORK_VIEW_PRIORITY,
    [ViewType.MY_WORK_VIEW_FROM_USER]   : MyWorkViewName.MY_WORK_VIEW_FROM_USER
}


export const myWorkViewOptionDictionary: {[K in MyWorkViewName]?: Option} = {
    [MyWorkViewName.MY_WORK_VIEW_DAY]: {
        value: ViewType.MY_WORK_VIEW_DAY,
        label: "Day",
        icon: "i5-day"
    },

    [MyWorkViewName.MY_WORK_VIEW_BOARD]: {
        value: ViewType.MY_WORK_VIEW_BOARD,
        label: "Week",
        icon: "i5-board"
    },

    [MyWorkViewName.MY_WORK_VIEW_SPLIT]: {
        value: ViewType.MY_WORK_VIEW_SPLIT,
        label: "Split",
        icon: "i5-board-view"
    },

    [MyWorkViewName.MY_WORK_VIEW_CALENDAR]: {
        value: ViewType.MY_WORK_VIEW_CALENDAR,
        label: "Month",
        icon: "i5-calendar"
    },

    [MyWorkViewName.MY_WORK_VIEW_UPCOMING]: {
        value: ViewType.MY_WORK_VIEW_UPCOMING,
        label: "Upcoming",
        icon: "i5-upcoming"
    },

    [MyWorkViewName.MY_WORK_VIEW_PROJECT]: {
        value: ViewType.MY_WORK_VIEW_PROJECT,
        label: "Project",
        icon: "i5-project"
    },

    [MyWorkViewName.MY_WORK_VIEW_FROM_USER]: {
        value: ViewType.MY_WORK_VIEW_FROM_USER,
        label: "From user",
        icon: "i5-users"
    },

    [MyWorkViewName.MY_WORK_VIEW_TYPE]: {
        value: ViewType.MY_WORK_VIEW_TYPE,
        label: "Type",
        icon: "i5-type",
    },

    [MyWorkViewName.MY_WORK_VIEW_PRIORITY]: {
        value: ViewType.MY_WORK_VIEW_PRIORITY,
        label: "Priority",
        icon: "i5-priority"
    }
}

